import apisauce from 'apisauce';

export default () => {
    const api = apisauce.create({
        baseURL: `${process.env.REACT_APP_API}/auth`,
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'json'
    });

    const login = (dbname, username, password) => api.post('login', {
        dbname, username, password
    });

    const verifyEmail = (dbname, username, verificationCode) => api.post('verifyEmail', {
        dbname, username, verificationCode
    });

    return {
        login,
        verifyEmail
    };
};
